import React from "react";
import { View, StyleSheet } from "react-native";
import { Colors } from "@config/colors";
import LoadingOverlay from "@Core/Auth/components/UI/LoadingOverlay";

const LoadingScreen: React.FC<{}> = () => {
  return (
    <View style={styles.screen}>
      <LoadingOverlay />
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colors.backgroundPrimary,
  },
});

export default LoadingScreen;
